import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css'; // For stars

// --- 1. NEW: Image URLs for the pre-designed cards ---
// (Replace these with your actual image paths)
const reviewCardImages = [
    'https://skillsuprise.com/data/cyberPDF/reviews/r1.png',
    'https://skillsuprise.com/data/cyberPDF/reviews/r2.png',
    'https://skillsuprise.com/data/cyberPDF/reviews/r3.png',
    'https://skillsuprise.com/data/cyberPDF/reviews/r4.png'
];

// --- 2. SIMPLIFIED: Internal CSS ---
// (All complex card-building styles have been removed)
const internalCSS = `
  /* --- Main Container --- */
  .reviews-container {
    background-color: #0d2a4f; /* Dark blue background */
    padding: 4rem 1rem;
    font-family: 'Poppins', sans-serif;
  }

  /* --- Title Section --- */
  .reviews-title-section {
    text-align: center;
    margin-bottom: 3rem;
  }

  .reviews-main-title {
    font-size: 2.8rem;
    font-weight: 700;
    color: #fff;
    margin-bottom: 1rem;
  }

  /* Star Ratings */
  .star-ratings {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffc107; /* Yellow stars */
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .star-ratings i {
    margin: 0 0.2rem;
  }
  .rating-text {
    font-size: 1.1rem;
    color: #adb5bd; /* Light grey text */
    margin-left: 0.75rem;
    font-weight: 500;
  }

  /* Decorative line */
  .title-decorator-reviews {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 1.5rem;
  }
  .decorator-line-reviews {
    height: 2px;
    width: 60px;
    background: linear-gradient(to right, transparent, #ffc107, transparent);
  }
  .decorator-icon-reviews {
    color: #ffc107;
    font-size: 1.2rem;
    margin: 0 0.5rem;
  }

  /* --- NEW: Simple Review Card Style --- */
  .review-image-card {
    background-color: transparent; /* Background is in the image */
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    height: 100%;
  }
  
  .review-image-card img {
     width: 100%;
     height: 100%;
     object-fit: cover;
     display: block; /* Removes any bottom spacing */
  }


  /* --- View All Button --- */
  .view-all-btn-section {
    text-align: center;
    margin-top: 3rem;
  }

  .btn-view-all {
    background-color: #ffc107; /* Yellow */
    color: #333;
    font-size: 1.1rem;
    font-weight: 600;
    padding: 0.75rem 2.5rem;
    border-radius: 50px; /* Pill shape */
    border: none;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;
  }
  
  .btn-view-all:hover {
     background-color: #ffca2c;
     box-shadow: 0 6px 15px rgba(0, 0, 0, 0.15);
     transform: translateY(-2px);
  }

  /* --- Responsive Adjustments --- */
   @media (max-width: 991.98px) { /* Tablets */
     .reviews-main-title { 
       font-size: 2.4rem;
     }
   }

  @media (max-width: 767.98px) { /* Mobile Devices */
    .reviews-main-title {
      font-size: 2rem;
    }
    .star-ratings {
       font-size: 1.3rem;
    }
    .rating-text {
       font-size: 0.7rem;
    }
     .btn-view-all {
        font-size: 1rem;
        padding: 0.6rem 2rem;
     }
  }
`;

const StudentReviews = () => {

  return (
    <>
      <style>{internalCSS}</style>
      
      <div className="reviews-container">
        <div className="container">
            {/* --- 1. Title Section --- */}
            <div className="reviews-title-section">
              <h1 className="reviews-main-title">Students Reviews</h1>
              <div className="star-ratings">
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-fill"></i>
                  <i className="bi bi-star-half"></i> 
                  <span className="rating-text">( 4.8 ) 20,000+ Ratings</span>
              </div>
               <div className="title-decorator-reviews">
                    <div className="decorator-line-reviews"></div>
                    <span className="decorator-icon-reviews">✦</span> 
                    <div className="decorator-line-reviews"></div>
               </div>
            </div>

            {/* --- 2. Reviews Grid (SIMPLIFIED) --- */}
            <div className="review-grid">
               {/* This row-cols-2 class creates the 2-column layout on mobile */}
               <div className="row row-cols-2 g-4">
                 
                 {/* Map over the simple image array */}
                 {reviewCardImages.map((imgSrc, index) => (
                   <div className="col" key={index}>
                     <div className="review-image-card">
                        <img src={imgSrc} alt={`Student Review ${index + 1}`} className="img-fluid" />
                     </div>
                   </div>
                 ))}
                 
               </div>
            </div>

             {/* --- 3. View All Button --- */}
             <div className="view-all-btn-section">
                <button className="btn btn-view-all">
                    View All Reviews
                </button>
             </div>
        </div>
      </div>
    </>
  );
};

export default StudentReviews;